/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable react/prop-types */
import React, {useEffect, useState} from 'react';
import SelectDropDown from '../UI/Form/SelectDropDown';
import MultiSelectFromList from '../Component/Form/MultiSelectFromList';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import BooleanField from '../UI/Form/BooleanField';
import ColorSelect from '../UI/Form/ColorSelect';

const Attributes = ({
  attributeData,
  setAttributeData,

  attributes,
}) => {
  const [displayColorPicker, setdisplayColorPicker] = useState(null);

  // functions

  const fileUploadClick = id => {
    let fileInput = document.getElementById(`fileUploadClick-${id}`);
    fileInput.click();
  };

  return (
    <>
      {attributes?.map(attr => {
        return (
          <div className="  block mb-2">
            {/* Field type 1 */}
            {attr.field_type === 1 && (
              <div className="      ">
                <div className=" w-full flex items-start justify-start   gap-1   ">
                  <span
                    className={
                      attr.optional
                        ? 'flex-none text-gray-600   '
                        : "flex-none    relative after:content-['*']  text-gray-600 after:text-red-500 after:-top-[5px] after:-right-[10px] "
                    }>
                    {attr.name}
                  </span>
                  {attr?.tooltip && (
                    <button className="tooltip">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                        class="w-6 h-6  ">
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z"
                        />
                      </svg>

                      <span className="top_hover text-primary">
                        {attr?.tooltip}
                      </span>
                    </button>
                  )}
                </div>

                <SelectDropDown
                  list={attr.values?.map(item => {
                    return {label: item.name, value: item.id};
                  })}
                  id={attr?.id}
                  name={attr.name}
                  setValue={item => {
                    if (item) {
                      attributeData?.length > 0
                        ? setAttributeData([
                            {values: [item], id: attr?.id},
                            ...attributeData?.filter(
                              filter_att => filter_att?.id !== attr?.id,
                            ),
                          ])
                        : setAttributeData([{values: [item], id: attr?.id}]);
                    } else {
                      setAttributeData([
                        ...attributeData?.filter(
                          filter_att => filter_att?.id !== attr?.id,
                        ),
                      ]);
                    }
                  }}
                  selected_value={
                    attributeData
                      ? attributeData?.filter(atData => atData?.id == attr?.id)
                          .length > 0
                        ? {
                            label: attr.values.filter(item => {
                              if (
                                attributeData?.filter(
                                  atData => atData?.id === attr?.id,
                                )[0]?.values[0] == item.id
                              ) {
                                return item;
                              }
                            })[0].name,
                            value: attr.values.filter(item => {
                              if (
                                attributeData?.filter(
                                  atData => atData?.id === attr?.id,
                                )[0]?.values[0] == item.id
                              ) {
                                return item;
                              }
                            })[0].id,
                          }
                        : null
                      : null
                  }
                  default_text={'Select'}
                />
              </div>
            )}

            {/* Field type 2*/}
            {attr.field_type === 2 && (
              <div className="      ">
                <div className=" w-full flex items-start justify-start   gap-1   ">
                  <span
                    className={
                      attr.optional
                        ? 'flex-none text-gray-600   '
                        : "flex-none    relative after:content-['*']  text-gray-600 after:text-red-500 after:-top-[5px] after:-right-[10px] "
                    }>
                    {attr.name}
                  </span>
                  {attr?.tooltip && (
                    <button className="tooltip">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                        class="w-6 h-6  ">
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z"
                        />
                      </svg>

                      <span className="top_hover text-primary">
                        {attr?.tooltip}
                      </span>
                    </button>
                  )}
                </div>
                <MultiSelectFromList
                  default_text={'Select value...'}
                  list={attr.values?.map((value, index) => {
                    return {
                      value: value?.id,
                      label: value.name,
                    };
                  })}
                  setValue={value => {
                    attributeData?.length > 0
                      ? value.length > 0
                        ? setAttributeData([
                            {
                              id: attr?.id,
                              values: value,
                            },
                            ...attributeData?.filter(
                              filter_att => filter_att?.id !== attr?.id,
                            ),
                          ])
                        : setAttributeData([
                            ...attributeData?.filter(
                              filter_att => filter_att?.id !== attr?.id,
                            ),
                          ])
                      : setAttributeData([
                          {
                            id: attr?.id,
                            values: value,
                          },
                        ]);
                  }}
                  selected_value={
                    attributeData?.filter(
                      single_at => single_at?.id == attr?.id,
                    )[0]?.values || []
                  }
                />
              </div>
            )}

            {/* Field type 3 */}
            {attr.field_type === 3 && (
              <div className="      ">
                <div className=" w-full flex items-start justify-start   gap-1   ">
                  <span
                    className={
                      attr.optional
                        ? 'flex-none text-gray-600   '
                        : "flex-none    relative after:content-['*']  text-gray-600 after:text-red-500 after:-top-[5px] after:-right-[10px] "
                    }>
                    {attr.name}
                  </span>
                  {attr?.tooltip && (
                    <button className="tooltip">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                        class="w-6 h-6  ">
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z"
                        />
                      </svg>

                      <span className="top_hover text-primary">
                        {attr?.tooltip}
                      </span>
                    </button>
                  )}
                </div>
                <input
                  value={
                    attributeData?.filter(atData => atData?.id === attr?.id)[0]
                      ?.values[0]
                  }
                  type="text"
                  className="form-input py-2 w-full "
                  placeholder={'Type ' + attr.name}
                  onChange={e => {
                    attributeData?.length > 0
                      ? e.target.value.replace(/ /g, '').length > 0
                        ? setAttributeData([
                            {values: [e.target.value], id: attr?.id},
                            ...attributeData?.filter(
                              filter_att => filter_att?.id !== attr?.id,
                            ),
                          ])
                        : setAttributeData([
                            ...attributeData?.filter(
                              filter_att => filter_att?.id !== attr?.id,
                            ),
                          ])
                      : setAttributeData([
                          {values: [e.target.value], id: attr?.id},
                        ]);
                  }}
                />
              </div>
            )}

            {/* Field type 4*/}
            {attr.field_type === 4 && (
              <div className="     ">
                <div className=" w-full flex items-start justify-start   gap-1   ">
                  <span
                    className={
                      attr.optional
                        ? 'flex-none text-gray-600   '
                        : "flex-none    relative after:content-['*']  text-gray-600 after:text-red-500 after:-top-[5px] after:-right-[10px] "
                    }>
                    {attr.name}
                  </span>
                  {attr?.tooltip && (
                    <button className="tooltip">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                        class="w-6 h-6  ">
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z"
                        />
                      </svg>

                      <span className="top_hover text-primary">
                        {attr?.tooltip}
                      </span>
                    </button>
                  )}
                </div>

                <input
                  value={attributeData
                    ?.filter(atData => atData?.id === attr?.id)[0]
                    ?.values.toString()}
                  type="text"
                  className=" form-input py-2 w-full
                  "
                  placeholder={'Using a comma, you can enter several values.'}
                  onChange={e => {
                    attributeData?.length > 0
                      ? e.target.value.replace(/ /g, '').length > 0
                        ? setAttributeData([
                            {
                              values: e.target.value.split(','),
                              id: attr?.id,
                            },
                            ...attributeData?.filter(
                              filter_att => filter_att?.id !== attr?.id,
                            ),
                          ])
                        : setAttributeData([
                            ...attributeData?.filter(
                              filter_att => filter_att?.id !== attr?.id,
                            ),
                          ])
                      : setAttributeData([
                          {
                            values: e.target.value.split(','),
                            id: attr?.id,
                          },
                        ]);
                  }}
                />
              </div>
            )}

            {/* Field type 5 */}
            {attr.field_type === 5 && (
              <>
                <div className=" w-full flex items-start justify-start   gap-1   ">
                  <span
                    className={
                      attr.optional
                        ? 'flex-none text-gray-600   '
                        : "flex-none    relative after:content-['*']  text-gray-600 after:text-red-500 after:-top-[5px] after:-right-[10px] "
                    }>
                    {attr.name}
                  </span>
                  {attr?.tooltip && (
                    <button className="tooltip">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                        class="w-6 h-6  ">
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z"
                        />
                      </svg>

                      <span className="top_hover text-primary">
                        {attr?.tooltip}
                      </span>
                    </button>
                  )}
                </div>
                {!attributeData?.filter(at_filter => attr.id == at_filter.id)
                  .length > 0 ? (
                  <div className="mt-3">
                    <div>
                      <div className=" h-0 overflow-hidden">
                        <input
                          type="file"
                          value={''}
                          id={`fileUploadClick-${attr.id}`}
                          name="imageUpload"
                          onChange={e => {
                            attributeData?.length > 0
                              ? setAttributeData([
                                  {
                                    values: [e.target.files[0]],
                                    id: attr.id,
                                    uploadFile: true,
                                  },
                                  ...attributeData?.filter(
                                    filter_att => filter_att?.id !== attr?.id,
                                  ),
                                ])
                              : setAttributeData([
                                  {
                                    values: [e.target.files[0]],
                                    id: attr.id,
                                    uploadFile: true,
                                  },
                                ]);
                          }}
                        />
                      </div>
                      <button
                        className=" flex flex-col items-center justify-center w-full p-3 border-2 border-dashed border-primary  "
                        onClick={() => fileUploadClick(attr.id)}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-9 w-9"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor">
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
                          />
                        </svg>
                        <p
                          className={
                            attr.optional
                              ? ''
                              : "after:content-['*']  text-gray-600 after:text-red-500 after:-top-[5px] after:-right-[10px] "
                          }>
                          Upload Attachment
                        </p>
                      </button>
                    </div>
                  </div>
                ) : attributeData?.filter(
                    at_filter => attr.id == at_filter.id,
                  )[0].uploadFile ? (
                  <div className=" mt-2  flex flex-col items-center px-[10px] py-[5px] border-2 border-dashed border-primary rounded-card  ">
                    <div className=" flex flex-col text-base  ">
                      <span>
                        {
                          attributeData?.filter(
                            at_filter => attr.id == at_filter.id,
                          )[0].values[0].name
                        }
                      </span>
                    </div>
                    <div
                      className="flex justify-end cursor-pointer  text-gray-600 after:text-red-500 mt-2"
                      onClick={() =>
                        setAttributeData([
                          ...attributeData?.filter(
                            filter_att => filter_att?.id !== attr?.id,
                          ),
                        ])
                      }>
                      Cancel
                    </div>
                  </div>
                ) : (
                  <div className=" mt-2  flex flex-col items-center px-[10px] py-[5px] border-2 border-dashed border-primary rounded-card  ">
                    <div className=" flex flex-col text-base  ">
                      <span>
                        {
                          attributeData
                            ?.filter(at_filter => attr.id == at_filter.id)[0]
                            .values[0].split('/')
                            .reverse()[0]
                        }
                      </span>
                    </div>
                    <div
                      className="flex justify-end cursor-pointer  text-gray-600 after:text-red-500 mt-2"
                      onClick={() =>
                        setAttributeData([
                          ...attributeData?.filter(
                            filter_att => filter_att?.id !== attr?.id,
                          ),
                        ])
                      }>
                      Cancel
                    </div>
                  </div>
                )}
              </>
            )}
            {/* Field type 6 */}
            {attr.field_type === 6 && (
              <div className="">
                <div className=" w-full flex items-start justify-start   gap-1   ">
                  <span
                    className={
                      attr.optional
                        ? 'flex-none text-gray-600   '
                        : "flex-none    relative after:content-['*']  text-gray-600 after:text-red-500 after:-top-[5px] after:-right-[10px] "
                    }>
                    {attr.name}
                  </span>
                  {attr?.tooltip && (
                    <button className="tooltip">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                        class="w-6 h-6  ">
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z"
                        />
                      </svg>

                      <span className="top_hover text-primary">
                        {attr?.tooltip}
                      </span>
                    </button>
                  )}
                </div>

                <textarea
                  className=" form-input py-2 w-full"
                  value={
                    attributeData?.filter(atData => atData?.id === attr?.id)[0]
                      ?.values[0] || ' '
                  }
                  onChange={e => {
                    const text = e.target.value;
                    attributeData?.length > 0
                      ? text.replace(/ /g, '').length > 0
                        ? setAttributeData([
                            {values: [text], id: attr?.id},
                            ...attributeData?.filter(
                              filter_att => filter_att?.id !== attr?.id,
                            ),
                          ])
                        : setAttributeData([
                            ...attributeData?.filter(
                              filter_att => filter_att?.id !== attr?.id,
                            ),
                          ])
                      : setAttributeData([{values: [text], id: attr?.id}]);
                  }}
                />
              </div>
            )}

            {/* Field type 7 */}
            {attr.field_type === 7 && (
              <div className="      ">
                <div className=" w-full flex items-start justify-start   gap-1   ">
                  <span
                    className={
                      attr.optional
                        ? 'flex-none text-gray-600   '
                        : "flex-none    relative after:content-['*']  text-gray-600 after:text-red-500 after:-top-[5px] after:-right-[10px] "
                    }>
                    {attr.name}
                  </span>
                  {attr?.tooltip && (
                    <button className="tooltip">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                        class="w-6 h-6  ">
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z"
                        />
                      </svg>

                      <span className="top_hover text-primary">
                        {attr?.tooltip}
                      </span>
                    </button>
                  )}
                </div>
                <DatePicker
                  selected={
                    attributeData
                      ?.filter(atData => atData?.id === attr?.id)[0]
                      ?.values.toString()
                      ? moment(
                          attributeData
                            ?.filter(atData => atData?.id === attr?.id)[0]
                            ?.values.toString(),
                        ).toDate()
                      : null
                  }
                  placeholderText={'Select Date & Time'}
                  timeInputLabel="Time:"
                  dateFormat="MM/dd/yyyy h:mm:ss"
                  showTimeInput={true}
                  className="
                    mt-0
                    block
                    w-full
                    px-0.5 
                    border-0 border-b-2 border-gray-200 transition  duration-700
                    focus:ring-0 focus:border-primary
                  "
                  onChange={date => {
                    attributeData?.length > 0
                      ? date
                        ? setAttributeData([
                            {
                              values: [
                                moment(date).format('yyyy-MM-DD HH:mm:ss'),
                              ],
                              id: attr?.id,
                            },
                            ...attributeData?.filter(
                              filter_att => filter_att?.id !== attr?.id,
                            ),
                          ])
                        : setAttributeData([
                            ...attributeData?.filter(
                              filter_att => filter_att?.id !== attr?.id,
                            ),
                          ])
                      : setAttributeData([
                          {
                            values: [
                              moment(date).format('yyyy-MM-DD HH:mm:ss'),
                            ],
                            id: attr?.id,
                          },
                        ]);
                  }}
                />
              </div>
            )}

            {/* Field type 8 */}

            {attr.field_type === 8 && (
              <div className="     ">
                <div className=" w-full flex items-start justify-start   gap-1   ">
                  <span
                    className={
                      attr.optional
                        ? 'flex-none text-gray-600   '
                        : "flex-none    relative after:content-['*']  text-gray-600 after:text-red-500 after:-top-[5px] after:-right-[10px] "
                    }>
                    {attr.name}
                  </span>
                  {attr?.tooltip && (
                    <button className="tooltip">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                        class="w-6 h-6  ">
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z"
                        />
                      </svg>

                      <span className="top_hover text-primary">
                        {attr?.tooltip}
                      </span>
                    </button>
                  )}
                </div>
                <input
                  value={attributeData
                    ?.filter(atData => atData?.id === attr?.id)[0]
                    ?.values.toString()}
                  type="number"
                  className=" form-input py-2 w-full"
                  placeholder={'1234'}
                  onChange={e => {
                    attributeData?.length > 0
                      ? e.target.value.replace(/ /g, '').length > 0
                        ? setAttributeData([
                            {
                              values: [e.target.value],
                              id: attr?.id,
                            },
                            ...attributeData?.filter(
                              filter_att => filter_att?.id !== attr?.id,
                            ),
                          ])
                        : setAttributeData([
                            ...attributeData?.filter(
                              filter_att => filter_att?.id !== attr?.id,
                            ),
                          ])
                      : setAttributeData([
                          {
                            values: [e.target.value],
                            id: attr?.id,
                          },
                        ]);
                  }}
                  onWheel={event => event.currentTarget.blur()}
                />
              </div>
            )}

            {/* Field type 9*/}

            {attr.field_type === 9 && (
              <div className="     ">
                <div className=" w-full flex items-start justify-start   gap-1   ">
                  <span
                    className={
                      attr.optional
                        ? 'flex-none text-gray-600   '
                        : "flex-none    relative after:content-['*']  text-gray-600 after:text-red-500 after:-top-[5px] after:-right-[10px] "
                    }>
                    {attr.name}
                  </span>
                  {attr?.tooltip && (
                    <button className="tooltip">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                        class="w-6 h-6  ">
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z"
                        />
                      </svg>

                      <span className="top_hover text-primary">
                        {attr?.tooltip}
                      </span>
                    </button>
                  )}
                </div>
                <div className="mt-3">
                  <BooleanField
                    current_data={
                      attributeData?.filter(
                        atData => atData?.id === attr?.id,
                      )[0]?.values[0]
                    }
                    update_data={value => {
                      attributeData?.length > 0
                        ? value === true
                          ? setAttributeData([
                              {
                                values: [value],
                                id: attr?.id,
                              },
                              ...attributeData?.filter(
                                filter_att => filter_att?.id !== attr?.id,
                              ),
                            ])
                          : setAttributeData([
                              ...attributeData?.filter(
                                filter_att => filter_att?.id !== attr?.id,
                              ),
                            ])
                        : value === true &&
                          setAttributeData([
                            {
                              values: [value],
                              id: attr?.id,
                            },
                          ]);
                    }}
                  />
                </div>
              </div>
            )}

            {/* Field type 10*/}
            {attr.field_type === 10 && (
              <div className="     ">
                <div className="mt-3">
                  <div className=" w-full flex items-start justify-start   gap-1  mb-3 ">
                    <span
                      className={
                        attr.optional
                          ? 'flex-none text-gray-600   '
                          : "flex-none    relative after:content-['*']  text-gray-600 after:text-red-500 after:-top-[5px] after:-right-[10px] "
                      }>
                      {attr.name}
                    </span>
                    {attr?.tooltip && (
                      <button className="tooltip">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke-width="1.5"
                          stroke="currentColor"
                          class="w-6 h-6  ">
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z"
                          />
                        </svg>

                        <span className="top_hover text-primary">
                          {attr?.tooltip}
                        </span>
                      </button>
                    )}
                  </div>
                  <ColorSelect
                    current_value={
                      attributeData?.filter(
                        atData => atData?.id === attr?.id,
                      )[0]?.values[0]
                    }
                    onUpdate={color =>
                      attributeData?.length > 0
                        ? color
                          ? setAttributeData([
                              {
                                values: [color],
                                id: attr?.id,
                              },
                              ...attributeData?.filter(
                                filter_att => filter_att?.id !== attr?.id,
                              ),
                            ])
                          : setAttributeData([
                              ...attributeData?.filter(
                                filter_att => filter_att?.id !== attr?.id,
                              ),
                            ])
                        : setAttributeData([
                            {
                              values: [color],
                              id: attr?.id,
                            },
                          ])
                    }
                  />
                </div>
              </div>
            )}

            {/* Field type 11 */}
            {attr.field_type === 11 && (
              <>
                <div className=" w-full flex items-start justify-start   gap-1   ">
                  <span
                    className={
                      attr.optional
                        ? 'flex-none text-gray-600   '
                        : "flex-none    relative after:content-['*']  text-gray-600 after:text-red-500 after:-top-[5px] after:-right-[10px] "
                    }>
                    {attr.name}
                  </span>
                  {attr?.tooltip && (
                    <button className="tooltip">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                        class="w-6 h-6  ">
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z"
                        />
                      </svg>

                      <span className="top_hover text-primary">
                        {attr?.tooltip}
                      </span>
                    </button>
                  )}
                </div>
                {!attributeData?.filter(at_filter => attr.id == at_filter.id)
                  .length > 0 ? (
                  <div className="mt-3">
                    <div>
                      <div className=" h-0 overflow-hidden">
                        <input
                          type="file"
                          value={''}
                          id={`fileUploadClick-${attr.id}`}
                          name="imageUpload"
                          accept=".json"
                          onChange={e => {
                            const file_name = e.target.files[0].name;

                            if (
                              file_name.split('.')[
                                file_name.split('.').length - 1
                              ] === 'json'
                            ) {
                              const fileReader = new FileReader();
                              fileReader.readAsText(e.target.files[0], 'UTF-8');
                              fileReader.onload = e => {
                                attributeData?.length > 0
                                  ? setAttributeData([
                                      {
                                        values: [JSON.parse(e.target.result)],
                                        id: attr.id,
                                      },
                                      ...attributeData?.filter(
                                        filter_att =>
                                          filter_att?.id !== attr?.id,
                                      ),
                                    ])
                                  : setAttributeData([
                                      {
                                        values: [JSON.parse(e.target.result)],
                                        id: attr.id,
                                      },
                                    ]);
                              };
                            }
                          }}
                        />
                      </div>
                      <button
                        className=" flex flex-col items-center justify-center w-full p-3 border-2 border-dashed border-primary  "
                        onClick={() => fileUploadClick(attr.id)}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-9 w-9"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor">
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
                          />
                        </svg>
                        <p
                          className={
                            attr.optional
                              ? ''
                              : "after:content-['*']  text-gray-600 after:text-red-500 after:-top-[5px] after:-right-[10px] "
                          }>
                          Upload Json File
                        </p>
                      </button>
                    </div>
                  </div>
                ) : attributeData?.filter(
                    at_filter => attr.id == at_filter.id,
                  )[0].uploadFile ? (
                  <div className=" mt-2  flex flex-col items-center px-[10px] py-[5px] border-2 border-dashed border-primary rounded-card  ">
                    <div className=" flex flex-col text-base  ">
                      <span>
                        {
                          attributeData?.filter(
                            at_filter => attr.id == at_filter.id,
                          )[0].values[0].name
                        }
                      </span>
                    </div>
                    <div
                      className="flex justify-end cursor-pointer  text-gray-600 after:text-red-500 mt-2"
                      onClick={() =>
                        setAttributeData([
                          ...attributeData?.filter(
                            filter_att => filter_att?.id !== attr?.id,
                          ),
                        ])
                      }>
                      Cancel
                    </div>
                  </div>
                ) : (
                  <div className=" mt-2  flex flex-col items-center px-[10px] py-[5px] border-2 border-dashed border-primary rounded-card  ">
                    <div className=" flex flex-col text-base  ">
                      <span>
                        {JSON.stringify(
                          attributeData?.filter(
                            at_filter => attr.id == at_filter.id,
                          )[0],
                        ).length > 50 ? (
                          <>
                            {JSON.stringify(
                              attributeData?.filter(
                                at_filter => attr.id == at_filter.id,
                              )[0],
                            ).substring(0, 50) + '...'}
                            <button
                              onClick={() => {
                                /* Copy the text inside the text field */
                                navigator.clipboard.writeText(
                                  JSON.stringify(
                                    attributeData?.filter(
                                      at_filter => attr.id == at_filter.id,
                                    )[0],
                                  ),
                                );

                                /* Alert the copied text */
                                alert('Copied the value');
                              }}
                              className="text-primary text-sm">
                              Copy
                            </button>
                          </>
                        ) : (
                          JSON.stringify(
                            attributeData?.filter(
                              at_filter => attr.id == at_filter.id,
                            )[0],
                          )
                        )}
                      </span>
                    </div>
                    <div
                      className="flex justify-end cursor-pointer  text-gray-600 after:text-red-500 mt-2"
                      onClick={() =>
                        setAttributeData([
                          ...attributeData?.filter(
                            filter_att => filter_att?.id !== attr?.id,
                          ),
                        ])
                      }>
                      Cancel
                    </div>
                  </div>
                )}
              </>
            )}
            {/* Field type 12 */}
            {attr.field_type === 12 && (
              <>
                <div className=" w-full flex items-start justify-start   gap-1   ">
                  <span
                    className={
                      attr.optional
                        ? 'flex-none text-gray-600   '
                        : "flex-none    relative after:content-['*']  text-gray-600 after:text-red-500 after:-top-[5px] after:-right-[10px] "
                    }>
                    {attr.name}
                  </span>
                  {attr?.tooltip && (
                    <button className="tooltip">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                        class="w-6 h-6  ">
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z"
                        />
                      </svg>

                      <span className="top_hover text-primary">
                        {attr?.tooltip}
                      </span>
                    </button>
                  )}
                </div>
                <div className="">
                  <input
                    value={
                      attributeData?.filter(
                        atData => atData?.id === attr?.id,
                      )[0]?.values[0]?.latitude &&
                      attributeData?.filter(
                        atData => atData?.id === attr?.id,
                      )[0]?.values[0]?.longitude
                        ? `${
                            attributeData?.filter(
                              atData => atData?.id === attr?.id,
                            )[0]?.values[0]?.latitude
                          },${
                            attributeData?.filter(
                              atData => atData?.id === attr?.id,
                            )[0]?.values[0]?.longitude
                          }`
                        : attributeData?.filter(
                            atData => atData?.id === attr?.id,
                          )[0]?.values[0] || ''
                    }
                    type="text"
                    className="form-input py-2 w-full"
                    placeholder="Enter proper latitude,longitude (e.g. 12.34,56.78)"
                    onChange={e => {
                      const inputValue = e.target.value;

                      if (!inputValue) {
                        // Handle empty input
                        setAttributeData([
                          ...attributeData?.filter(
                            filter_att => filter_att?.id !== attr?.id,
                          ),
                        ]);
                        return;
                      }

                      if (inputValue.includes(',')) {
                        // Only validate when there's a comma
                        const [lat, lng] = inputValue
                          .split(',')
                          .map(val => parseFloat(val.trim()));

                        if (lat && lng && !isNaN(lat) && !isNaN(lng)) {
                          // Valid latitude and longitude
                          attributeData?.length > 0
                            ? setAttributeData([
                                {
                                  values: [
                                    {
                                      latitude: lat,
                                      longitude: lng,
                                    },
                                  ],
                                  id: attr?.id,
                                },
                                ...attributeData?.filter(
                                  filter_att => filter_att?.id !== attr?.id,
                                ),
                              ])
                            : setAttributeData([
                                {
                                  values: [
                                    {
                                      latitude: lat,
                                      longitude: lng,
                                    },
                                  ],
                                  id: attr?.id,
                                },
                              ]);
                        } else {
                          // Invalid coordinates but keep the raw input
                          attributeData?.length > 0
                            ? setAttributeData([
                                {
                                  values: [inputValue],
                                  id: attr?.id,
                                },
                                ...attributeData?.filter(
                                  filter_att => filter_att?.id !== attr?.id,
                                ),
                              ])
                            : setAttributeData([
                                {
                                  values: [inputValue],
                                  id: attr?.id,
                                },
                              ]);
                        }
                      } else {
                        // Store raw input while typing
                        attributeData?.length > 0
                          ? setAttributeData([
                              {
                                values: [inputValue],
                                id: attr?.id,
                              },
                              ...attributeData?.filter(
                                filter_att => filter_att?.id !== attr?.id,
                              ),
                            ])
                          : setAttributeData([
                              {
                                values: [inputValue],
                                id: attr?.id,
                              },
                            ]);
                      }
                    }}
                  />
                </div>
              </>
            )}

            {/* Field type 13 */}
            {/* {attr.field_type === 13 && (
              <>
                <AudioPicker
                  title={attr.name}
                  isOptional={attr.optional}
                  tooltip_text={attr?.tooltip}
                  current_value={
                    attributeData?.filter(
                      at_filter => attr.id == at_filter.id,
                    )[0]?.values[0]?.name
                  }
                  add_file_title={General_text.general.upload_audio}
                  button_icon={AllIcons.audio_icon}
                  set_new_value={files => {
                    attributeData?.length > 0
                      ? setAttributeData([
                          {
                            values: [files[0]],
                            id: attr.id,
                            uploadFile: true,
                          },
                          ...attributeData?.filter(
                            filter_att => filter_att?.id !== attr?.id,
                          ),
                        ])
                      : setAttributeData([
                          {
                            values: [files[0]],
                            id: attr.id,
                            uploadFile: true,
                          },
                        ]);
                  }}
                  delete_file={() =>
                    setAttributeData([
                      ...attributeData?.filter(
                        filter_att => filter_att?.id !== attr?.id,
                      ),
                    ])
                  }
                  max_size={200}
                  min_size={0}
                  setIsError={setShowError}
                  setErrorMessage={setErrormessage}
                />
              </>
            )} */}
            {/* Field type 14 */}
            {/* {attr.field_type === 14 && (
              <VideoPicker
                title={attr.name}
                isOptional={attr.optional}
                tooltip_text={attr?.tooltip}
                current_value={
                  attributeData?.filter(at_filter => attr.id == at_filter.id)[0]
                    ?.values[0]?.name
                }
                add_file_title={General_text.general.upload_video}
                set_new_value={files => {
                  attributeData?.length > 0
                    ? setAttributeData([
                        {
                          values: [files[0]],
                          id: attr.id,
                          uploadFile: true,
                        },
                        ...attributeData?.filter(
                          filter_att => filter_att?.id !== attr?.id,
                        ),
                      ])
                    : setAttributeData([
                        {
                          values: [files[0]],
                          id: attr.id,
                          uploadFile: true,
                        },
                      ]);
                }}
                delete_file={() =>
                  setAttributeData([
                    ...attributeData?.filter(
                      filter_att => filter_att?.id !== attr?.id,
                    ),
                  ])
                }
                max_size={500}
                min_size={0}
                setIsError={setShowError}
                setErrorMessage={setErrormessage}
              />
            )} */}
          </div>
        );
      })}
    </>
  );
};

export default Attributes;
